import React, { useState, useEffect, useRef } from 'react';
import ErpTemplate from '../../../components/ErpTemplate';
import { FaSave } from 'react-icons/fa';
import api from '../../../services/api';
import { useHistory } from 'react-router-dom';
import ReactSelect from '../../../components/ReactSelect';
import { bin2hex } from '../../../util/util';
import { toast } from 'react-toastify';
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { CKEditor } from '@ckeditor/ckeditor5-react'
import { FinField, FinInput } from '../../../components/FinField';
import MenuContextoEditor from '../../../components/MenuContextoEditor';
import '../../../css/financeiro-parcela-pagar.css';

// Rotulo de um cliente do modelo, no formato da listagem. O cadastro excluido aparece marcado:
// ele continua restringindo o modelo, e sem a marca ninguem entende por que esta ali.
const rotuloCliente = (c) => ([c.codigo, c.nome, c.municipio ? c.municipio + ' - ' + c.uf : null]
    .filter(Boolean).join(' - ') || String(c.id)) + (c.excluido ? ' (excluído)' : '');

const TAGS = [
    {
        categoria: 'Participante',
        tags: [
            { label: 'Nome (com Dr.)', tag: '{nomeparticipante}' },
            { label: 'Nome', tag: '{nome}' },
            { label: 'E-mail', tag: '{email}' },
            { label: 'CPF', tag: '{cpf}' },
            { label: 'CRM/CRO', tag: '{crm}' },
            { label: 'UF CRM', tag: '{crmuf}' },
            { label: 'Especialidade', tag: '{especialidade}' },
            { label: 'Data de Nascimento', tag: '{datanascimento}' },
            { label: 'Passaporte', tag: '{passaporte}' },
            { label: 'Documentos Entrada no País (participante ou padrão do evento; só com aéreo internacional)', tag: '{documentosentradapais}' },
            { label: 'Ciência dos Documentos - declarou ou não declarou', tag: '{cienteDocumentosEntradaPais}' },
            { label: 'Pendência de Documentos - o que o convidado declarou, ou "não informado"', tag: '{pendenciaDocumentosEntradaPais}' },
            { label: 'Telefone', tag: '{telefone}' },
            { label: 'Celular', tag: '{celular}' },
            { label: 'Vínculo Órgão Público', tag: '{opcaoVinculoOrgaoPublico}' },
            { label: 'IP', tag: '{ip}' },
        ]
    },
    {
        categoria: 'Evento',
        tags: [
            { label: 'Nome do Evento', tag: '{evento.nome}' },
            { label: 'Nome do Evento (RSVP)', tag: '{evento.nomersvp}' },
            { label: 'Data e Hora', tag: '{evento.dataHora}' },
            { label: 'Data e Hora Fim', tag: '{evento.dataHoraFim}' },
            { label: 'Texto de Data', tag: '{evento.textodata}' },
            { label: 'Local', tag: '{evento.local}' },
            { label: 'Local (alias)', tag: '{local}' },
            { label: 'Cidade (município ou exterior, já formatado)', tag: '{evento.cidade}' },
            { label: 'Município', tag: '{evento.municipio.nome}' },
            { label: 'Município Exterior', tag: '{evento.municipioExterior}' },
            { label: 'Logomarca', tag: '{evento.logomarca}' },
            { label: 'Logomarca (Cliente)', tag: '{evento.cliente.logomarca}' },
            { label: 'Agenda Prévia', tag: '{agendaprevia}' },
            { label: 'Data Limite Aceite', tag: '{dataLimiteAceite}' },
            { label: 'Formato do Evento', tag: '{formatoEvento}' },
            { label: 'Coordenador RSVP', tag: '{evento.coordenadorrsvp.nome}' },
            { label: 'Telefone Coordenador RSVP', tag: '{evento.telefonecoordenadorrsvp}' },
            { label: 'E-mail Remetente', tag: '{evento.emailremetente}' },
        ]
    },
    {
        categoria: 'Hospedagem',
        tags: [
            { label: 'Hotel', tag: '{hotelnome}' },
            { label: 'Hora Check-in', tag: '{hotelhoracheckin}' },
            { label: 'Hora Check-out', tag: '{hotelhoracheckout}' },
            { label: 'Observação Hospedagem', tag: '{textohotelobservacao}' },
        ]
    },
    {
        categoria: 'Aéreo',
        tags: [
            { label: 'Tabela Aéreo', tag: '{tabelaaereo}' },
            { label: 'Obs. Aéreo Ida', tag: '{textoaereoidaobservacao}' },
            { label: 'Obs. Aéreo Retorno', tag: '{textoaereoretornoobservacao}' },
        ]
    },
    {
        categoria: 'Transfer',
        tags: [
            { label: 'Observação Transfer', tag: '{textotransferobservacao}' },
            { label: 'Observação Transfer Extra', tag: '{textotransferextraobservacao}' },
        ]
    },
    {
        categoria: 'Despesas',
        tags: [
            { label: 'Lista de Despesas Patrocinadas', tag: '{listadespesaspatrocinadas}' },
        ]
    },
    {
        categoria: 'Datas',
        tags: [
            { label: 'Data Atual', tag: '{dataAtual}' },
            { label: 'Data Carta Enviada', tag: '{dataCartaEnviada}' },
            { label: 'Data e Hora Atual', tag: '{dataHoraAtual}' },
            { label: 'Data e Hora Assinatura', tag: '{dataHoraCartaAssinada}' },
            { label: 'Data e Hora da Ciência dos Documentos', tag: '{dataHoraCienteDocumentos}' },
        ]
    },
    {
        categoria: 'Ações',
        tags: [
            { label: 'Botões Aceitar/Recusar', tag: '{opcaoconvite}' },
            // Não existem variantes "ingles" destas duas: o backend não tem case para elas e o botão sai
            // vazio. As tags abaixo já são bilíngues — montam o link com ?lang= e o rótulo via getText.
            { label: 'Botão Confirmar Dados', tag: '{botaoconfirmardados}' },
            { label: 'Botão Confirmar Carta Informativa', tag: '{botaoconfirmarCartaInformativa}' },
            { label: 'Imagem Assinatura', tag: '{imagemAssinaturaCartaConvite}' },
        ]
    },
    {
        categoria: 'Condicionais',
        tags: [
            { label: 'Se tem Aéreo', tag: '{se.aereo}', bloco: true },
            { label: 'Se tem Hospedagem', tag: '{se.hotelhospedagem}', bloco: true },
            { label: 'Se tem Transfer', tag: '{se.transfer}', bloco: true },
            { label: 'Se tem Transfer Extra', tag: '{se.transferextra}', bloco: true },
            // D-0094: evento com seguro terrestre E participante com transfer ou transfer extra.
            { label: 'Se tem Seguro Terrestre (evento com seguro + transfer ou transfer extra)', tag: '{se.seguroterrestre}', bloco: true },
            { label: 'Se tem Inscrição', tag: '{se.inscricao}', bloco: true },
            { label: 'Se Inscrição Online', tag: '{se.tipoinscricao=online}', bloco: true },
            { label: 'Se Inscrição Presencial', tag: '{se.tipoinscricao=presencial}', bloco: true },
            { label: 'Se tem Despesas Patrocinadas', tag: '{se.despesaspatrocinadas}', bloco: true },
            { label: 'Se idioma = Português', tag: '{se.idioma=portugues}', bloco: true },
            { label: 'Se idioma = Inglês', tag: '{se.idioma=ingles}', bloco: true },
            { label: 'Se HCP', tag: '{se.tipoparticipante=hcp}', bloco: true },
            { label: 'Se HCP Virtual', tag: '{se.tipoparticipante=hcpvirtual}', bloco: true },
            { label: 'Se Palestrante', tag: '{se.tipoparticipante=palestrante}', bloco: true },
            { label: 'Se Quarto não é Duplo', tag: '{se.nao.hoteltipoquarto=duplo}', bloco: true },
            { label: 'Se Convite Aceito', tag: '{se.aceiteconvite}', bloco: true },
            { label: 'Se Tem Documentos de Entrada no País (aéreo + internacional)', tag: '{se.documentosEntradaPais}', bloco: true },
            // Escondem o rótulo junto com o valor ("no <local>", "cidade de <cidade>", "Agenda prévia:").
            { label: 'Se Tem Local', tag: '{se.local}', bloco: true },
            { label: 'Se Tem Cidade', tag: '{se.cidade}', bloco: true },
            { label: 'Se Tem Agenda Prévia', tag: '{se.agendaprevia}', bloco: true },
        ]
    },
    // Colunas resolvidas direto pelo caminho no array (EventoCartaController::get_multi), sem passar
    // pelo switch: saem como estão no banco — slug em minúsculo, sem quebra de linha em <br> e, nos
    // campos de aéreo, com os trechos separados por "|" (só a {tabelaaereo} troca o pipe por <br>).
    // Exceção: as datas de hotel já chegam em d/m/Y, formatadas antes da substituição.
    // Nos campos de aéreo há outro buraco: em trecho que o convidado marcou como "não utilizarei", o
    // escolhaAereo nunca grava as colunas aereoida*/aereoretorno* — mas também nunca as limpa, então
    // elas saem vazias OU com o valor antigo, se o operador tiver preenchido o trecho à mão na tela
    // interna. Quem precisa cobrir a recusa deve usar {tabelaaereo} e {textoaereoidaobservacao}, que
    // são os únicos que tratam o trecho recusado.
    // Só entram aqui relações que o montaPdfCarta carrega — é ele que renderiza TODOS os tipos de
    // modelo desta tela, inclusive os de e-mail.
    {
        categoria: 'Campos Diretos (valor cru do banco)',
        tags: [
            { label: 'Código do Participante', tag: '{codigo}' },
            { label: 'Identificação Laboratório', tag: '{identificacao}' },
            { label: 'RG', tag: '{rg}' },
            { label: 'Outros E-mails', tag: '{emailsecundario}' },
            { label: 'Telefone 2', tag: '{telefone2}' },
            { label: 'Nome para o Crachá', tag: '{contato}' },
            { label: 'Instituição', tag: '{instituicao}' },
            { label: 'Conselho', tag: '{conselho}' },
            { label: 'UF do Conselho', tag: '{conselhouf}' },
            { label: 'Especificação do Vínculo (sem quebra de linha)', tag: '{especificacaoVinculo}' },
            { label: 'Documentos Entrada no País - padrão do evento, valor cru (sem quebra de linha)', tag: '{evento.documentos_entrada_pais}' },
            { label: 'Observações Importantes / Observação do questionário (sem quebra de linha)', tag: '{observacao}' },
            { label: 'Restrição Alimentar', tag: '{restricaoalimentar}' },
            { label: 'PCD', tag: '{pcd}' },
            { label: 'Acompanhantes (sem quebra de linha)', tag: '{acompanhantes}' },

            { label: 'Endereço - Logradouro', tag: '{enderecologradouro}' },
            { label: 'Endereço - Número', tag: '{endereconumero}' },
            { label: 'Endereço - Complemento', tag: '{enderecocomplemento}' },
            { label: 'Endereço - Bairro', tag: '{enderecobairro}' },
            { label: 'Endereço - CEP', tag: '{enderecocep}' },
            { label: 'Endereço - UF', tag: '{enderecouf}' },

            { label: 'Aeroporto de Origem', tag: '{aeroportoOrigem}' },

            { label: 'Hotel - Tipo de Quarto', tag: '{hoteltipoquarto}' },
            { label: 'Hotel - Data Check-in', tag: '{hoteldatacheckin}' },
            { label: 'Hotel - Data Check-out', tag: '{hoteldatacheckout}' },
            { label: 'Hotel - Logradouro', tag: '{hotellogradouro}' },
            { label: 'Hotel - Bairro', tag: '{hotelbairro}' },
            { label: 'Hotel - Município', tag: '{hotelmunicipio.nome}' },
            { label: 'Hotel - Telefone', tag: '{hoteltelefone}' },

            { label: 'Aéreo Ida - Data', tag: '{aereoidadata}' },
            { label: 'Aéreo Ida - Origem', tag: '{aereoidaorigem}' },
            { label: 'Aéreo Ida - Destino', tag: '{aereoidadestino}' },
            { label: 'Aéreo Ida - Companhia', tag: '{aereoidacompanhia}' },
            { label: 'Aéreo Ida - Voo', tag: '{aereoidavoo}' },
            { label: 'Aéreo Ida - Hora Saída', tag: '{aereoidahorasaida}' },
            { label: 'Aéreo Ida - Hora Chegada', tag: '{aereoidahorachegada}' },
            { label: 'Aéreo Ida - Localizador', tag: '{aereoidalocalizador}' },
            { label: 'Aéreo Ida - E-ticket', tag: '{aereoidaeticket}' },
            { label: 'Aéreo Ida - Conexão', tag: '{aereoidaconexao}' },

            { label: 'Aéreo Retorno - Data', tag: '{aereoretornodata}' },
            { label: 'Aéreo Retorno - Origem', tag: '{aereoretornoorigem}' },
            { label: 'Aéreo Retorno - Destino', tag: '{aereoretornodestino}' },
            { label: 'Aéreo Retorno - Companhia', tag: '{aereoretornocompanhia}' },
            { label: 'Aéreo Retorno - Voo', tag: '{aereoretornovoo}' },
            { label: 'Aéreo Retorno - Hora Saída', tag: '{aereoretornohorasaida}' },
            { label: 'Aéreo Retorno - Hora Chegada', tag: '{aereoretornohorachegada}' },
            { label: 'Aéreo Retorno - Localizador', tag: '{aereoretornolocalizador}' },
            { label: 'Aéreo Retorno - E-ticket', tag: '{aereoretornoeticket}' },
            { label: 'Aéreo Retorno - Conexão', tag: '{aereoretornoconexao}' },

            { label: 'Inscrição - Número', tag: '{inscricaonumero}' },
            // Coluna individual: no híbrido vem do cadastro, e HCP Virtual grava "online" em qualquer
            // formato. As condicionais {se.tipoinscricao=...} NÃO leem esta coluna fora do híbrido —
            // elas passam por resolveTipoInscricao, que deriva do evento. Podem divergir.
            { label: 'Tipo de Inscrição (valor cru, pode divergir da condicional)', tag: '{tipoinscricao}' },

            { label: 'Evento - Identificação', tag: '{evento.identificacao}' },
            { label: 'Evento - Código', tag: '{evento.codigo}' },
            { label: 'Evento - Descrição (só evento interno, sem quebra de linha)', tag: '{evento.observacao}' },
            { label: 'Evento - Endereço', tag: '{evento.endereco}' },
            { label: 'Evento - Bairro', tag: '{evento.bairro}' },
            { label: 'Evento - CEP', tag: '{evento.enderecocep}' },
            { label: 'Evento - UF do Município', tag: '{evento.municipio.uf}' },
            { label: 'Evento - Nacionalidade (nacional/internacional)', tag: '{evento.nacionalidade}' },
            { label: 'Evento - Tipo de Lista (adesao/lista)', tag: '{evento.tipoIngresso}' },
            { label: 'Evento - Link', tag: '{evento.link}' },
            { label: 'Evento - Link Final de Cadastro', tag: '{evento.linkfinalcadastro}' },
            { label: 'Evento - Título do E-mail', tag: '{evento.titulo_email}' },
            { label: 'Evento - E-mail de Backup', tag: '{evento.emailbackup}' },
            { label: 'Cliente - Nome', tag: '{evento.cliente.nome}' },
            { label: 'Cliente - Nome Fantasia', tag: '{evento.cliente.nomefantasia}' },

            ...Array.from({ length: 10 }, (_, i) => (
                { label: `Coluna Nomeável ${i + 1} - Valor`, tag: `{coluna${i + 1}}` }
            )),
            ...Array.from({ length: 10 }, (_, i) => (
                { label: `Coluna Nomeável ${i + 1} - Título`, tag: `{evento.nomecoluna${i + 1}}` }
            )),
        ]
    },
];

const TIPO_OPTIONS = [
    { value: 'emailconvite', label: 'E-mail Convite' },
    { value: 'emailinformativa', label: 'E-mail Informativa' },
    { value: 'contrato', label: 'Contrato' },
    { value: 'convite', label: 'Convite' },
    { value: 'informativa', label: 'Informativa' },
    { value: 'termoaceite', label: 'Termo de Aceite' },
    { value: 'certificado', label: 'Certificado' },
];

const EVENTO_TIPO_OPTIONS = [
    { value: 'advisoryboard', label: 'Advisory Board' },
    { value: 'congresso', label: 'Congresso' },
    { value: 'convencaonacional', label: 'Convenção' },
    { value: 'estandecotapat', label: 'Estande e/ou Cota de Patrocínio' },
    { value: 'eventoexclusivo', label: 'Evento Exclusivo' },
    { value: 'eventointerno', label: 'Evento Interno' },
    { value: 'eventoterceiros', label: 'Evento de Terceiros' },
    { value: 'minimeet', label: 'Mini Meeting' },
    { value: 'orgsede', label: 'Organizado Pela Sede' },
    { value: 'simposio', label: 'Simpósio' },
];

const REALIZACAO_OPTIONS = [
    { value: 'digital', label: 'Digital' },
    { value: 'presencial', label: 'Presencial' },
    { value: 'hibrido', label: 'Híbrido' },
];

const NACIONALIDADE_OPTIONS = [
    { value: 'nacional', label: 'Nacional' },
    { value: 'internacional', label: 'Internacional' },
];

/**
 * Selos nas tags da carta, so no desenho do editor.
 *
 * A tag e texto puro no conteudo. Cada ocorrencia de uma tag da lista ganha um marker do CKEditor
 * (`usingOperation: false`, `affectsData: false`) com desenho registrado SO no editingDowncast. O
 * getData() — que e o que a tela salva —, o codigo-fonte e o copiar/colar passam pelo dataDowncast e
 * nao veem nada. Sem `affectsData`, o `change:data` nao dispara: o onChange da tela nao roda e o
 * desfazer nao ganha passo.
 *
 * Condicional abre e fecha com a mesma tag, entao elas sao pareadas na ordem do texto. No hover de
 * uma delas, outro marker cobre o trecho entre as duas; a que fica sem par sai em alerta. Tag que nao
 * esta na lista fica sem selo, e nao como erro: o back pode aceitar tag que o painel nao lista.
 */
function ligarSelosDeTag(editor, tags) {
    const GRUPO = 'seloTag';
    // Qualquer coisa entre chaves, sem chave nem espaco dentro: condicional de valor carrega `=`
    // ({se.idioma=portugues}). Quem decide se ganha selo e a lista, por igualdade exata.
    const TAG_NO_TEXTO = /\{[^{}\s]+\}/g;
    const model = editor.model;

    const simples = new Set();
    const condicionais = new Set();
    tags.forEach((categoria) => categoria.tags.forEach((t) => (t.bloco ? condicionais : simples).add(t.tag)));

    const opcoesMarker = (range) => ({ range, usingOperation: false, affectsData: false });

    // Prioridade baixa deixa o selo POR FORA das marcas do texto (negrito, cor, tamanho), que seguem
    // aparecendo dentro dele. A area do hover fica por fora de tudo.
    editor.conversion.for('editingDowncast').markerToHighlight({
        model: GRUPO,
        view: ({ markerName }) => {
            const [, tipo, par] = markerName.split(':');

            if (tipo === 'area') return { classes: 'fin-pp__selo-area', priority: 1 };
            if (tipo === 'orfao') return { classes: ['fin-pp__selo-tag', 'is-orfao'], priority: 2, attributes: { title: 'Condicional sem fechamento' } };
            if (tipo === 'bloco') return { classes: ['fin-pp__selo-tag', 'is-bloco'], priority: 2, attributes: { 'data-selo-par': par } };

            return { classes: 'fin-pp__selo-tag', priority: 2 };
        },
    });

    let agendado = null;
    let areaAtual = null;

    const recalcular = () => {
        agendado = null;
        if (editor.state === 'destroyed') return;

        areaAtual = null;

        model.change((writer) => {
            for (const marker of Array.from(model.markers.getMarkersGroup(GRUPO))) {
                writer.removeMarker(marker);
            }

            const abertas = new Map();
            let sequencia = 0;

            for (const raiz of model.document.getRoots()) {
                for (const { item } of model.createRangeIn(raiz)) {
                    if (!item.is('element') || !model.schema.checkChild(item, '$text')) continue;

                    // Texto do bloco com os mesmos offsets do modelo: elemento em linha (quebra,
                    // imagem) ocupa uma posicao e nunca casa com a expressao.
                    const texto = Array.from(item.getChildren())
                        .map((filho) => (filho.is('$text') ? filho.data : '￼'))
                        .join('');

                    TAG_NO_TEXTO.lastIndex = 0;
                    let achado;
                    while ((achado = TAG_NO_TEXTO.exec(texto)) !== null) {
                        const tag = achado[0];
                        if (!simples.has(tag) && !condicionais.has(tag)) continue;

                        const range = writer.createRange(
                            writer.createPositionAt(item, achado.index),
                            writer.createPositionAt(item, achado.index + tag.length)
                        );

                        if (simples.has(tag)) {
                            writer.addMarker(`${GRUPO}:tag:${sequencia++}`, opcoesMarker(range));
                            continue;
                        }

                        const aberta = abertas.get(tag);
                        if (!aberta) {
                            abertas.set(tag, { range, par: sequencia++ });
                            continue;
                        }

                        abertas.delete(tag);
                        writer.addMarker(`${GRUPO}:bloco:${aberta.par}:a`, opcoesMarker(aberta.range));
                        writer.addMarker(`${GRUPO}:bloco:${aberta.par}:f`, opcoesMarker(range));
                    }
                }
            }

            abertas.forEach((aberta) => {
                writer.addMarker(`${GRUPO}:orfao:${aberta.par}`, opcoesMarker(aberta.range));
            });
        });
    };

    const mostrarArea = (par) => {
        if (par === areaAtual || editor.state === 'destroyed') return;

        model.change((writer) => {
            if (areaAtual !== null && model.markers.has(`${GRUPO}:area:${areaAtual}`)) {
                writer.removeMarker(`${GRUPO}:area:${areaAtual}`);
            }

            // Do range ATUAL dos selos, e nao de um guardado no recalculo: o marker acompanha a
            // edicao feita desde entao.
            const abre = par !== null ? model.markers.get(`${GRUPO}:bloco:${par}:a`) : null;
            const fecha = par !== null ? model.markers.get(`${GRUPO}:bloco:${par}:f`) : null;
            if (abre && fecha) {
                writer.addMarker(`${GRUPO}:area:${par}`, opcoesMarker(writer.createRange(abre.getStart(), fecha.getEnd())));
            }
        });

        areaAtual = par;
    };

    const aoPassar = (evento) => {
        const alvo = evento.target && evento.target.closest ? evento.target.closest('[data-selo-par]') : null;
        mostrarArea(alvo ? alvo.getAttribute('data-selo-par') : null);
    };
    const aoSair = () => mostrarArea(null);

    // Recalcula depois de uma pausa na digitacao, e nao a cada tecla.
    const agendar = () => {
        if (agendado) clearTimeout(agendado);
        agendado = setTimeout(recalcular, 150);
    };

    model.document.on('change:data', agendar);

    const dom = editor.editing.view.getDomRoot();
    if (dom) {
        dom.addEventListener('mouseover', aoPassar);
        dom.addEventListener('mouseleave', aoSair);
    }

    editor.on('destroy', () => {
        if (agendado) clearTimeout(agendado);
        if (dom) {
            dom.removeEventListener('mouseover', aoPassar);
            dom.removeEventListener('mouseleave', aoSair);
        }
    });

    recalcular();
}

export default function CadastroEventoCarta({ match }) {
    const id = match.params.id;
    const token = localStorage.getItem('token');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [dados, setDados] = useState({ codigoFonte: false });
    const [carta, setCarta] = useState("");
    const history = useHistory();
    const editorRef = useRef(null);
    const [showTagPanel, setShowTagPanel] = useState(false);
    const [buscaTag, setBuscaTag] = useState("");
    const tagPanelRef = useRef(null);
    const showTagPanelSetterRef = useRef(null);
    showTagPanelSetterRef.current = setShowTagPanel;
    // Caixa do clique direito no editor ({ x, y } do clique), com formatacao e tags.
    const [menuEditor, setMenuEditor] = useState(null);
    // A selecao estava recolhida antes do clique direito? No Mac o proprio clique seleciona a
    // palavra sob o mouse, e a tag inserida a apagaria.
    const selecaoRecolhidaNoCliqueRef = useRef(true);

    const [idiomas, setIdiomas] = useState([]);
    const [tabIdioma, setTabIdioma] = useState('portugues');
    const tabIdiomaRef = useRef('portugues');
    const [traducoes, setTraducoes] = useState({});

    const cartaRef = useRef('');
    cartaRef.current = carta;
    const traducoeseRef = useRef({});
    traducoeseRef.current = traducoes;

    const buscar = () => {
        api({ method: "get", action: '/idioma', token })
            .then(r => setIdiomas(r.data.data ?? []))
            .catch(() => {});

        if (id) {
            api({
                method: "get",
                action: '/eventoCarta/' + id,
                token: token,
            }).then(response => {
                var dadosRecebidos = response.data.data;
                // Clientes do modelo no formato do select; lista vazia = vale para todos. O
                // cadastro excluido volta marcado e segue no salvar: tira-lo liberaria o modelo.
                dadosRecebidos.clientes = (dadosRecebidos.clientes ?? []).map(c => ({ value: c.id, label: rotuloCliente(c) }));
                setDados(dadosRecebidos);
                setCarta(dadosRecebidos.carta);
                if (editorRef.current && tabIdiomaRef.current === 'portugues') {
                    editorRef.current.setData(dadosRecebidos.carta);
                }
                const mapa = Object.fromEntries(
                    (dadosRecebidos.carta_traducoes ?? []).map(t => [t.idioma, t.carta ?? ''])
                );
                setTraducoes(mapa);
            }).catch(() => {});
        } else {
            setDados({ ...dados });
        }
    };

    const validar = () => {
        var tipo = document.querySelector("#tipo");
        if (dados.tipo === undefined || dados.tipo === '') {
            toast.error('É necessário preencher o tipo da carta');
            setTimeout(() => {
                tipo.focus();
            }, 500);
            return false;
        }
        return true;
    };

    const salvar = () => {
        if (!validar()) {
            return false;
        }
        if (isSubmitting) {
            return;
        }

        setIsSubmitting(true);

        const traducaoPayload = Object.entries(traducoes)
            .map(([idioma, carta]) => ({ idioma, carta: bin2hex(carta) }));

        if (id) {
            api({
                method: 'put',
                action: '/eventoCarta/' + id,
                token: token,
                data: {
                    ...dados,
                    carta: bin2hex(dados.carta),
                    // Modelo padrao (`fixo`) vale para todos os clientes: a API recusa vinculo nele, e a
                    // lista vazia tambem limpa um vinculo que ele tenha ganhado antes da trava.
                    clientes: dados.fixo ? [] : (dados.clientes ?? []).map(c => c.value),
                    traducoes: traducaoPayload,
                }
            })
                .then(() => {
                    toast.success("As alterações foram salvas com sucesso!");
                })
                .catch(error => {
                    toast.error('Erro ao salvar: ' + (error.response?.data?.error ?? error.message ?? ''));
                })
                .finally(() => {
                    setIsSubmitting(false);
                });
        } else {
            api({
                method: 'post',
                action: '/eventoCarta',
                token: token,
                data: {
                    ...dados,
                    carta: bin2hex(dados.carta),
                    clientes: (dados.clientes ?? []).map(c => c.value),
                    traducoes: traducaoPayload,
                }
            })
                .then(() => {
                    toast.success("Dados salvos com sucesso!");
                    history.push("/eventoCarta");
                })
                .catch(error => {
                    toast.error('Erro ao salvar: ' + (error.response?.data?.error ?? error.message ?? ''));
                })
                .finally(() => {
                    setIsSubmitting(false);
                });
        }
    };

    const mudarTabIdioma = (codigo) => {
        tabIdiomaRef.current = codigo;
        setTabIdioma(codigo);
        editorRef.current?.setData(codigo === 'portugues' ? carta : (traducoes[codigo] ?? ''));
    };

    // Só tira a tradução do estado: a exclusão de fato acontece no salvar, no mesmo endpoint — o
    // backend apaga as traduções que não vierem no payload.
    const removerTraducao = (codigo) => {
        setTraducoes(prev => {
            const proximo = { ...prev };
            delete proximo[codigo];
            return proximo;
        });
        if (tabIdiomaRef.current === codigo) {
            mudarTabIdioma('portugues');
        }
        toast.info('Tradução removida. Salve para confirmar.');
    };

    const inserirTag = (item, { recolherSelecao = false } = {}) => {
        const editor = editorRef.current;
        if (!editor) return;
        editor.model.change(writer => {
            const selection = editor.model.document.selection;
            // Selecao criada pelo proprio clique direito (Mac): a tag entra no ponto clicado em vez
            // de substituir a palavra. Condicional continua envolvendo o trecho selecionado.
            if (recolherSelecao && !item.bloco && !selection.isCollapsed) {
                writer.setSelection(selection.getFirstRange().end);
            }
            const attrs = Object.fromEntries(selection.getAttributes());

            if (item.bloco) {
                if (!selection.isCollapsed) {
                    const range = selection.getFirstRange();
                    writer.insertText(item.tag, attrs, range.end);
                    writer.insertText(item.tag, attrs, range.start);
                } else {
                    editor.model.insertContent(
                        writer.createText(`${item.tag}conteúdo${item.tag}`, attrs)
                    );
                }
            } else {
                editor.model.insertContent(writer.createText(item.tag, attrs));
            }
        });
        setShowTagPanel(false);
        setBuscaTag("");
    };

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (tagPanelRef.current && !tagPanelRef.current.contains(e.target)) {
                setShowTagPanel(false);
                setBuscaTag("");
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    useEffect(() => {
        buscar();
    },
        // eslint-disable-next-line
        []);

    const tagsFiltradas = buscaTag.trim()
        ? TAGS.map(c => ({
            ...c,
            tags: c.tags.filter(t =>
                t.label.toLowerCase().includes(buscaTag.toLowerCase()) ||
                t.tag.toLowerCase().includes(buscaTag.toLowerCase())
            )
        })).filter(c => c.tags.length > 0)
        : TAGS;

    return (
        <ErpTemplate>
            <div className="main-content container-fluid fin-pp">
                <div className="fin-pp__head">
                    <div>
                        <h1 className="fin-pp__title">Modelo de Carta</h1>
                        {dados.fixo && (
                            <span className="fin-pp__cell-muted" style={{ fontSize: 12 }}>
                                Modelo padrão do sistema: usado quando o evento não tem modelo próprio.
                                Pode ser editado, não pode ser excluído.
                            </span>
                        )}
                    </div>
                </div>

                <form onSubmit={(e) => { salvar(); e.preventDefault(); }}>
                    <div className="fin-pp__card" style={{ padding: 16, marginBottom: 16 }}>
                        <div className="fin-pp__filters">
                            <FinField label="Tipo da Carta">
                                <ReactSelect
                                    id="tipo"
                                    value={{ value: dados.tipo, label: dados.nomeTipo }}
                                    onChange={e => setDados({ ...dados, tipo: e.value, nomeTipo: e.label })}
                                    options={TIPO_OPTIONS}
                                />
                            </FinField>
                            <FinField grow label="Clientes">
                                {/* Travado no modelo padrao (`fixo`): o envio cai nele quando o evento nao tem
                                    modelo proprio, entao ele vale para todos os clientes. */}
                                <ReactSelect
                                    id="clientes"
                                    isMulti
                                    isDisabled={Boolean(dados.fixo)}
                                    placeholder={dados.fixo ? 'Todos os clientes (modelo padrão)' : 'Todos os clientes'}
                                    value={dados.clientes ?? []}
                                    onChange={e => setDados({ ...dados, clientes: e ?? [] })}
                                    loadOptions={(input) => {
                                        return api({
                                            method: 'get',
                                            action: '/participante',
                                            token: token,
                                            params: {
                                                nome: input,
                                                tipoCadastro: "cliente",
                                                situacaoRegistro: "ativo",
                                            }
                                        })
                                            .then(response => {
                                                return response.data.data.map((registro) => {
                                                    var label = registro.codigo +
                                                        ' - ' + registro.nome +
                                                        (registro.enderecomunicipio ? ' - ' + registro.enderecomunicipio.nome + '-' + registro.enderecomunicipio.uf : '') +
                                                        (registro.cnpj ? ' (' + registro.cnpj + ')' : '') +
                                                        (registro.cpf ? ' (' + registro.cpf + ')' : '') +
                                                        (registro.nomefantasia ? ' - ' + registro.nomefantasia : '');
                                                    return { value: registro.id, label };
                                                });
                                            })
                                            .catch(() => {});
                                    }}
                                />
                            </FinField>
                            <FinField label="Tipo do Evento">
                                <ReactSelect
                                    value={{ value: dados.eventoTipo, label: dados.nomeEventoTipo }}
                                    onChange={e => setDados({ ...dados, eventoTipo: e.value, nomeEventoTipo: e.label })}
                                    options={EVENTO_TIPO_OPTIONS}
                                />
                            </FinField>
                            <FinField label="Formato do Evento">
                                <ReactSelect
                                    value={{ value: dados.eventoTipoRealizacao, label: dados.nomeEventoTipoRealizacao }}
                                    onChange={e => setDados({ ...dados, eventoTipoRealizacao: e.value, nomeEventoTipoRealizacao: e.label })}
                                    options={REALIZACAO_OPTIONS}
                                />
                            </FinField>
                            <FinField label="Nacionalidade do Evento">
                                <ReactSelect
                                    id="nacionalidade"
                                    value={{ value: dados.eventoNacionalidade, label: dados.nomeEventoNacionalidade }}
                                    onChange={e => setDados({ ...dados, eventoNacionalidade: e.value, nomeEventoNacionalidade: e.label })}
                                    options={NACIONALIDADE_OPTIONS}
                                />
                            </FinField>
                            <div className="fin-pp__field fin-pp__field--full">
                                {/* O código é do registro, não do nome: fica ao lado do rótulo, como o painel
                                    já o mostra em coluna própria. Antes era um span absoluto sobreposto ao
                                    input com o padding calculado em `ch` — o span não centraliza vertical
                                    como o input e a conta não batia com a largura real, então "2 -" e o nome
                                    saíam desalinhados e sobrepostos. */}
                                <div className="fin-pp__field-head">
                                    <label className="fin-pp__label">Nome da Carta</label>
                                    {dados.codigo ? <span className="fin-pp__minitag">Código {dados.codigo}</span> : null}
                                </div>
                                <input
                                    type="text"
                                    className="fin-pp__input"
                                    id="nome"
                                    placeholder="Nome da carta"
                                    value={dados.nome || ''}
                                    onChange={e => setDados({ ...dados, nome: e.target.value })}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="fin-pp__card" style={{ padding: 16, marginBottom: 16 }}>
                        <div className="fin-pp__cphead" style={{ marginBottom: 12 }}>
                            <h2 className="fin-pp__cphead-title">Carta</h2>
                        </div>
                        <div className="d-flex justify-content-between align-items-end mb-0">
                            <ul className="nav nav-tabs mb-0" style={{ flex: 1 }}>
                                <li className="nav-item">
                                    <button
                                        type="button"
                                        className={`nav-link ${tabIdioma === 'portugues' ? 'active' : ''}`}
                                        onClick={() => mudarTabIdioma('portugues')}
                                    >
                                        Português
                                    </button>
                                </li>
                                {idiomas.filter(i => i.codigo !== 'portugues').map(i => (
                                    <li key={i.codigo} className="nav-item">
                                        <button
                                            type="button"
                                            className={`nav-link d-inline-flex align-items-center gap-2 ${tabIdioma === i.codigo ? 'active' : ''}`}
                                            onClick={() => mudarTabIdioma(i.codigo)}
                                        >
                                            {i.nome}
                                            {!!traducoes[i.codigo] && (
                                                <span
                                                    role="button"
                                                    tabIndex={-1}
                                                    aria-label={`Remover tradução em ${i.nome}`}
                                                    title="Remover esta tradução"
                                                    className="text-muted"
                                                    style={{ lineHeight: 1, fontSize: 16, cursor: 'pointer' }}
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        removerTraducao(i.codigo);
                                                    }}
                                                >
                                                    &times;
                                                </span>
                                            )}
                                        </button>
                                    </li>
                                ))}
                            </ul>
                            <button
                                type="button"
                                className="fin-pp__btn fin-pp__btn--sm"
                                style={{ marginBottom: 4 }}
                                onClick={() => {
                                    dados.codigoFonte = !dados.codigoFonte;
                                    setDados({ ...dados });
                                }}
                            >
                                Código Fonte
                            </button>
                        </div>
                        <div className="border border-top-0 p-2">
                            {dados.codigoFonte ?
                                <textarea
                                    className="fin-pp__input"
                                    id="carta"
                                    style={{ minHeight: "500px", height: "auto", padding: "10px 14px" }}
                                    value={tabIdioma === 'portugues' ? carta : (traducoes[tabIdioma] ?? '')}
                                    onChange={(e) => {
                                        const novaCarta = e.target.value;
                                        if (tabIdioma === 'portugues') {
                                            setDados({ ...dados, carta: novaCarta });
                                            setCarta(novaCarta);
                                        } else {
                                            setTraducoes(prev => ({ ...prev, [tabIdioma]: novaCarta }));
                                        }
                                    }}
                                />
                                :
                                <>
                                    <div className="position-relative" ref={tagPanelRef}>
                                        <div id="barraFerramentas"></div>
                                        {showTagPanel && (
                                            <div className="position-absolute end-0 bg-white border rounded shadow p-2" style={{ width: '320px', maxHeight: '480px', overflowY: 'auto', zIndex: 9999 }}>
                                                <input
                                                    autoFocus
                                                    type="text"
                                                    className="form-control form-control-sm mb-2"
                                                    placeholder="Buscar tag..."
                                                    value={buscaTag}
                                                    onChange={e => setBuscaTag(e.target.value)}
                                                />
                                                {tagsFiltradas.map(categoria => (
                                                    <div key={categoria.categoria}>
                                                        <div
                                                            className="text-uppercase fw-bold px-2 py-1 rounded"
                                                            style={{
                                                                fontSize: '11px',
                                                                background: 'var(--fin-sf2)',
                                                                color: 'var(--fin-mt)',
                                                                border: '1px solid var(--fin-bd)',
                                                                marginTop: 6,
                                                                marginBottom: 2,
                                                            }}
                                                        >
                                                            {categoria.categoria}
                                                        </div>
                                                        {categoria.tags.map(item => (
                                                            <div
                                                                key={item.tag}
                                                                onClick={() => inserirTag(item)}
                                                                className="d-flex justify-content-between align-items-center gap-2 px-2 py-1 rounded"
                                                                style={{ cursor: 'pointer' }}
                                                                onMouseEnter={e => e.currentTarget.classList.add('bg-light')}
                                                                onMouseLeave={e => e.currentTarget.classList.remove('bg-light')}
                                                            >
                                                                <span style={{ fontSize: '13px' }}>{item.label}</span>
                                                                <span className="text-muted text-nowrap font-monospace" style={{ fontSize: '11px' }}>{item.tag}</span>
                                                            </div>
                                                        ))}
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                    {/* Clique direito: caixa com formatacao e tags, atalho para nao voltar a
                                        barra do topo em carta longa. Shift + clique direito mantem o menu do
                                        navegador (corretor, colar). Ctrl nao serve: no Mac, Ctrl + clique e o
                                        proprio clique direito. */}
                                    <div
                                        onMouseDown={e => {
                                            if (e.button === 2 && editorRef.current) {
                                                selecaoRecolhidaNoCliqueRef.current = editorRef.current.model.document.selection.isCollapsed;
                                            }
                                        }}
                                        onContextMenu={e => {
                                            if (e.shiftKey || !editorRef.current) return;
                                            e.preventDefault();
                                            setShowTagPanel(false);
                                            setMenuEditor({ x: e.clientX, y: e.clientY });
                                        }}
                                    >
                                    <CKEditor
                                        editor={Editor}
                                        onReady={editor => {
                                            editorRef.current = editor;
                                            editor.setData(
                                                tabIdiomaRef.current === 'portugues'
                                                    ? cartaRef.current
                                                    : (traducoeseRef.current[tabIdiomaRef.current] ?? '')
                                            );
                                            ligarSelosDeTag(editor, TAGS);
                                            const toolbarContainer = document.querySelector('#barraFerramentas');
                                            if (toolbarContainer) {
                                                toolbarContainer.appendChild(editor.ui.view.toolbar.element);
                                            }
                                            if (editor.ui.componentFactory.has('inserirTag')) {
                                                editor.on('inserirTag', () => showTagPanelSetterRef.current(v => !v));
                                            } else {
                                                const btn = document.createElement('button');
                                                btn.type = 'button';
                                                btn.className = 'ck ck-button ck-off';
                                                btn.title = 'Inserir campo dinâmico';
                                                btn.style.cssText = 'padding:0 8px;';
                                                btn.innerHTML = '<span class="fw-bold">{ }</span>';
                                                btn.addEventListener('click', (e) => {
                                                    e.preventDefault();
                                                    showTagPanelSetterRef.current(v => !v);
                                                });
                                                const itemsEl = editor.ui.view.toolbar.element.querySelector('.ck-toolbar__items');
                                                (itemsEl ?? editor.ui.view.toolbar.element).appendChild(btn);
                                            }
                                        }}
                                        onChange={(event, editor) => {
                                            const data = editor.getData();
                                            if (tabIdiomaRef.current === 'portugues') {
                                                setDados({ ...dados, carta: data });
                                                setCarta(data);
                                            } else {
                                                setTraducoes(prev => ({ ...prev, [tabIdiomaRef.current]: data }));
                                            }
                                        }}
                                    />
                                    </div>
                                    {menuEditor && editorRef.current ? (
                                        <MenuContextoEditor
                                            key={`${menuEditor.x}-${menuEditor.y}`}
                                            editor={editorRef.current}
                                            posicao={menuEditor}
                                            tags={TAGS}
                                            onInserirTag={item => {
                                                inserirTag(item, { recolherSelecao: selecaoRecolhidaNoCliqueRef.current });
                                                setMenuEditor(null);
                                                editorRef.current?.editing.view.focus();
                                            }}
                                            onFechar={() => setMenuEditor(null)}
                                        />
                                    ) : null}
                                </>
                            }
                        </div>
                    </div>

                    <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 24 }}>
                        <button type="submit" className="fin-pp__btn fin-pp__btn--primary" disabled={isSubmitting}>
                            {isSubmitting
                                ? <><span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>Salvando...</>
                                : <><FaSave size={16} /> Salvar</>
                            }
                        </button>
                    </div>
                </form>
            </div>
        </ErpTemplate>
    );
}
